import { Customer } from "../../model/customer.model";
import type { FormikInitialValuesNewRequest } from "../../model/form.model";

export type StepValidation = { ok: true } | { ok: false; reason: string };

export function validatePurchaseStep(
  values: FormikInitialValuesNewRequest["purchase"],
  customer?: Customer
): StepValidation {
  if (customer && customer.products.length === 0) {
    return {
      ok: false,
      reason:
        "O cliente selecionado não possui produtos cadastrados. Entre em contato com o administrador para cadastrar os produtos antes de realizar o pedido.",
    };
  }

  if (!values.customerCnpj) {
    return { ok: false, reason: "Selecione um cliente." };
  }

  if (!values.deliveryAddressId) {
    return { ok: false, reason: "Selecione um endereço de entrega." };
  }

  if (!values.withdrawBasisId) {
    return { ok: false, reason: "Selecione uma base de retirada." };
  }

  if (!values.deliveryDate) {
    return { ok: false, reason: "Selecione uma data de entrega." };
  }

  return { ok: true };
}
